export default class Fileupload {
    constructor(el) {
        this.el = el;
        this.fileuploadInput = this.el.querySelector('#fileuploadInput');
        this.fileInfo = this.el.querySelector('.fileupload__info');
        this.initalPlaceholder = this.fileInfo.textContent;

        this.bindEvents();
    }

    bindEvents() {
        this.fileuploadInput.addEventListener('change', () => this.fileChanged());
    }

    fileChanged() {
        const fileName = this.fileuploadInput.value.replace(/^.*\\/, '');

        if (fileName.length > 0) {
            this.fileInfo.textContent = fileName;
        } else {
            this.reset();
        }
    }

    reset() {
        this.fileInfo.textContent = this.initalPlaceholder;
    }
}



// WEBPACK FOOTER //
// ./src/components/fileupload/fileupload.js